import gql from 'graphql-tag';

const CREATE_INVOICE_SCHEDULE = gql`
  mutation($input: CreateInvoiceScheduleInput!) {
    createInvoiceSchedule(input: $input) {
      scheduleId
      name
      description
      scheduleDefinition
      conditions {
        conditionId
        applicableItemType
        includeOverageItem
        applicableItemSubType
        conditionIncludedItems {
          itemId
        }
      }
      nextScheduleDate
      lastScheduleDate
      invoicePaymentTerm {
        paymentTermId
        paymentTermName
        paymentTermValue
        placeholder
        systemPaymentTerm
      }
      generateEmptyInvoice
      autoSend
      updatedBy {
        userId
        name
        firstName
        lastName
        email
      }
      createdTime
      updatedTime
      status
      overriddenSettings
    }
  }
`;

const UPDATE_INVOICE_SCHEDULE = gql`
  mutation($input: UpdateInvoiceScheduleInput!) {
    updateInvoiceSchedule(input: $input) {
      scheduleId
      name
      description
      scheduleDefinition
      conditions {
        conditionId
        applicableItemType
        includeOverageItem
        applicableItemSubType
        conditionIncludedItems {
          itemId
        }
      }
      nextScheduleDate
      lastScheduleDate
      invoicePaymentTerm {
        paymentTermId
        paymentTermName
        paymentTermValue
        placeholder
        systemPaymentTerm
      }
      generateEmptyInvoice
      autoSend
      updatedBy {
        userId
        name
        firstName
        lastName
        email
      }
      createdTime
      updatedTime
      status
      overriddenSettings
    }
  }
`;

const DELETE_INVOICE_SCHEDULE = gql`
  mutation($input: InvoiceScheduleIdentifierInput!) {
    deleteInvoiceSchedule(input: $input)
  }
`;

const DELETE_ALL_CLIENT_INVOICE_SCHEDULES = gql`
  mutation($input: ClientIdentifierInput!) {
    deleteAllClientInvoiceSchedules(input: $input)
  }
`;

export {
  CREATE_INVOICE_SCHEDULE,
  UPDATE_INVOICE_SCHEDULE,
  DELETE_INVOICE_SCHEDULE,
  DELETE_ALL_CLIENT_INVOICE_SCHEDULES
};
